import { useCallback, useEffect, useRef } from 'react'

export const useOutsideClickDetector = (
  ref: HTMLElement | null,
  callback: () => void,
  ignore?: HTMLElement | null,
) => {
  const clickHandlerRef = useRef<(event: MouseEvent) => void>()

  const handleClickOutside = useCallback(
    (event: MouseEvent) => {
      if (
        ref &&
        event.composedPath().indexOf(ref) === -1 &&
        (!ignore || event.composedPath().indexOf(ignore) === -1)
      ) {
        event.stopPropagation()
        callback()
      }
    },
    [ref, callback, ignore],
  )

  useEffect(() => {
    const cleanUp = () => {
      if (clickHandlerRef.current) {
        document.removeEventListener('click', clickHandlerRef.current, true)
      }
    }

    cleanUp()

    if (ref) {
      clickHandlerRef.current = handleClickOutside
      document.addEventListener('click', clickHandlerRef.current, true)
    }

    return cleanUp
  }, [handleClickOutside, ref])
}
